import React from 'react'
import {
    Radio,
    Checkbox
} from "antd";
export function Rendertext(props) {
    let data = props;
    return (
        <div className='row'>
            <div className='col-6'>
                <span className='font-thai-b fs-18'>
                    <span className="font-thai-b fs-18">
                        {data.label}
                    </span>
                </span>
            </div>
            <div className='col-6 pl-0'>
                <span
                    className='font-thai-sb fs-18 c-blue'
                    style={{ wordBreak: 'break-word' }}>
                    {data.value}
                </span>
            </div>
        </div>
    )
}

export function Rendercheckbox(props) {
    let data = props;
    return (
        <div className='row'>
            <div className='col-6'>
                <span className='font-thai-b fs-18'>
                    <span className='font-thai-b fs-18'>
                        {data.label}
                    </span>
                </span>
            </div>
            <div className='col-6 pl-0'>
                <span
                    className='font-thai-sb fs-18'
                    style={{ wordBreak: 'break-word' }}>
                    <Checkbox checked={true} disabled={false} >
                        <span className='font-thai-b fs-18 c-blue'>
                            {data.value}
                        </span>
                    </Checkbox>
                </span>
            </div>
        </div>
    );
}

export function Renderradio(props) {
    let data = props;
    return (
        <div className='row'>
            <div className='col-6'>
                <span className='font-thai-b fs-18'>
                    <span className='font-thai-b fs-18'>
                        {data.label}
                    </span>
                </span>
            </div>
            <div className='col-6 pl-0'>
                <span
                    className="font-thai-sb fs-18"
                >
                    <Radio.Group value={1} >
                        <Radio value={1}>
                            <span className='font-thai-b fs-18 c-blue'>
                                {data.value}
                            </span>
                        </Radio>
                    </Radio.Group>
                </span>
            </div>
        </div>
    )
}


